// extracted by mini-css-extract-plugin
module.exports = {"Booking":"booking-module--Booking--2xx_S"};